import { AppBar, Box, Container, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ConstantActions } from '../../../../Services/_actions';
import { globalpermissions } from '../../../../Services/Permission';
import useAppHeader from '../../hooks/useAppHeader';
import useAppShellSx from '../../hooks/useAppShellSx';
import useLayoutMode from '../../hooks/useLayoutMode';
import AppHeaderBrand from './AppHeaderBrand';
import AppHeaderNotifications from './AppHeaderNotifications';
import TestAppHeader from './TestAppHeader';

function redirectToPage(page, navigate) {
  if (page.startsWith('/#/')) {
    window.location.href = page;
  } else {
    navigate(page);
  }
}

export default function AppHeader() {
  const actions = ConstantActions();
  const navigate = useNavigate();
  const sx = useAppShellSx();
  const { header } = sx;
  const { hideHeader, showTestHeader } = useLayoutMode();
  const { logo, defaultLogo, unreadMessageCounts } = useAppHeader();

  if (hideHeader) {
    return null;
  }

  if (showTestHeader) {
    return <TestAppHeader logo={logo} defaultLogo={defaultLogo} />;
  }

  const dynamicLink = actions.getDynamicHomePageLink?.();
  const showNotifications = actions?.userHasPermission([
    globalpermissions?.notificationIcon?.notificationIcon,
  ]);

  return (
    <AppBar
      elevation={0}
      sx={{
        ...header.appBar,
        '&.MuiAppBar-root': { boxShadow: 'none' },
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={header.toolbar}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap', justifyContent: {xs:'flex-start',sm:'auto'} , width: {xs:'100%',sm:'auto'} }}>
            <AppHeaderBrand
              logo={logo}
              defaultLogo={defaultLogo}
              onLogoClick={
                dynamicLink ? () => redirectToPage(dynamicLink, navigate) : undefined
              }
            />
          </Box>

          {showNotifications && (
            <AppHeaderNotifications unreadMessageCounts={unreadMessageCounts} />
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
